/** About page: running head naming the chapter currently on screen. */
(function () {
  'use strict';
  const bq = window.bq;
  if (!bq) return;

  // The chapter crossing the band near the top of the window is the one named.
  function wireRail(root) {
    const rail = root.querySelector('[data-apropos-rail]');
    if (!rail || !('IntersectionObserver' in window)) return;

    const items = new Map();
    rail.querySelectorAll('[data-chap]').forEach(function (el) {
      items.set(el.dataset.chap, el);
    });
    const chapters = Array.prototype.filter.call(
      root.querySelectorAll('[data-apropos-chap]'),
      function (el) { return items.has(el.dataset.aproposChap); }
    );
    if (!chapters.length) return;

    const live = new Set();
    let shown = rail.querySelector('.is-actif');

    function show(id) {
      const el = items.get(id);
      if (!el || el === shown) return;
      if (shown) shown.classList.remove('is-actif');
      el.classList.add('is-actif');
      shown = el;
    }

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const id = entry.target.dataset.aproposChap;
        if (entry.isIntersecting) live.add(id);
        else live.delete(id);
      });
      // First in reading order touching the band; none means between two
      // chapters, so keep the current name.
      for (let i = 0; i < chapters.length; i += 1) {
        const id = chapters[i].dataset.aproposChap;
        if (live.has(id)) { show(id); return; }
      }
    }, { rootMargin: '-35% 0px -60% 0px', threshold: 0 });

    chapters.forEach(function (chap) { io.observe(chap); });
  }

  function init(root) {
    if (!root || root.dataset.bqAproposInit) return;
    root.dataset.bqAproposInit = '1';

    if (window.bqReveal) window.bqReveal(root, '[data-apropos-reveal]');
    bq.wireNuwa(root, '[data-apropos-nuwa]');
    wireRail(root);
  }

  document.querySelectorAll('.bq-apropos').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bq-apropos').forEach(init);
  });
})();
